
export function getUrlPathname(url: string): string {
    if (!url) {
        return '';
    }
    try {
        return new URL(url).pathname;
    } catch (e) {
        // url is relative or otherwise not parsable as an absolute URL - strip query/fragment manually
        return url.split(/[?#]/)[0];
    }
}





// WEBPACK FOOTER //
// ./src/main/webapp/components/nddUtils/urlUtil.ts